import { application } from "./application";
import NotificationTestController from "./notification_test_controller";
import SnsUrlClearController from "./sns_url_clear_controller";
import ImageSortableController from "./report/image_sortable_controller";

application.register("notification-test", NotificationTestController);
application.register("sns-url-clear", SnsUrlClearController);
application.register("report--image-sortable", ImageSortableController);
